import React, {
    ChangeEvent,
    ForwardedRef,
    forwardRef,
    InputHTMLAttributes,
} from "react";
import styled from "styled-components";

interface Props {
    name: string; // used as accessor for onChangeHandler
    value?: string; // value passed to raw input
    onChangeHandler: (e: ChangeEvent<HTMLInputElement>) => void;
}

const BasicInput = forwardRef(
    (
        {
            name,
            value,
            onChangeHandler,
            ...delegated
        }: Props & InputHTMLAttributes<HTMLInputElement>,
        ref?: ForwardedRef<HTMLInputElement>
    ) => {
        return (
            <StyledInput
                name={name}
                ref={ref}
                value={value || ""}
                onChange={onChangeHandler}
                {...delegated}
            />
        );
    }
);

const StyledInput = styled.input<{ isDisabled?: boolean }>`
    border: solid 1px ${(props) => props.theme.colors.neutral[300]};
    border-radius: 0.2rem;

    color: ${(props) => props.theme.colors.neutral[600]};

    font-size: 1rem;
    font-weight: ${(props) => props.theme.fontWeight.normal};
    font-family: inherit;

    height: 2rem;
    padding-left: 0.5rem;

    &:hover {
        background-color: ${(props) => props.theme.colors.neutral[25]};
    }

    &:disabled {
        background-color: ${(props) => props.theme.colors.neutral[150]};

        &:hover {
            background-color: ${(props) => props.theme.colors.neutral[150]};
        }
    }
`;

export default BasicInput;
